import { URL_CONSTANTS } from '../../util/constants';
import { getItemFromPageModel, respGridUtil } from '../../util/helpers';
import { ResponsiveGrid } from '@adobe/aem-react-editable-components';
import { StyledLayoutContainer } from './index.styles';
import Head from 'next/head';
import Props from './index.type';
import { useCreateSurveyStore } from '../../store/createSurveyStore';
const { NEXT_PUBLIC_AEM_PATH } = process.env;
const { ITEM_PATH_HEADER, ITEM_PATH_FOOTER } = URL_CONSTANTS;

export const Layout = ({ children, title, metaNames, metaProps, pageIdentifier, model, brandCode }: Props) => {
  const headerModel = getItemFromPageModel(model, ITEM_PATH_HEADER),
    footerModel = getItemFromPageModel(model, ITEM_PATH_FOOTER),
    headerModelProps = respGridUtil(headerModel),
    footerModelProps = respGridUtil(footerModel);
  const { formData } = useCreateSurveyStore();

  const finalBrandCode = !brandCode ? formData?.brandCode : brandCode;
  let cssClass = '';

  // If NBF is true, use luxury-group CSS regardless of brand code
  if (model?.accData?.property_config?.non_branded_flg === 'Y') {
    cssClass = 'LG';
  }

  return (
    <StyledLayoutContainer>
      <Head>
        <meta charSet="UTF-8" />
        <title>{title}</title>
        <link rel="icon" type="image/x-icon" href={model?.favIcon == '' ? formData?.favIcon : model?.favIcon} />
        {metaNames?.map(metaName => (
          <meta key={metaName.name} name={metaName.name} content={metaName.value}></meta>
        ))}
        {metaProps?.map(metaProperty => (
          <meta key={metaProperty.name} property={metaProperty.name} content={metaProperty.value}></meta>
        ))}
        <link rel="canonical" href={model?.canonical} />
      </Head>
      <div data-brand={finalBrandCode} className="m-prearrival-components" aria-atomic={true}>
        <ResponsiveGrid
          {...headerModelProps}
          model={headerModel}
          pagePath={NEXT_PUBLIC_AEM_PATH}
          itemPath={ITEM_PATH_HEADER}
        />

        <div
          id="main-content"
          data-brand={finalBrandCode}
          className={`${model?.cssClassNames} ${pageIdentifier} ${cssClass}`}
        >
          {children}
        </div>

        <ResponsiveGrid
          {...footerModelProps}
          model={footerModel}
          pagePath={NEXT_PUBLIC_AEM_PATH}
          itemPath={ITEM_PATH_FOOTER}
        />
      </div>
    </StyledLayoutContainer>
  );
};
